import React from 'react';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';

export type AvatarWithFallbackProps = {
  imageUrl?: string;
  imageTitle?: string;
  className?: string;
  shape?: 'square' | 'circle';
  size?: 'small' | 'medium' | 'large' | 'custom';
  colorScheme?: 'dark' | 'light';
  isBordered?: boolean;
};

// The Agency API returns a low-resolution placeholder image url, rather than
// null, when an agent has no real photo.
export const isNoAgentPhoto = (imageUrl?: string | null): boolean =>
  Boolean(imageUrl?.includes('noAgentPhoto'));

const AvatarWithFallback = ({
  imageUrl = undefined,
  ...props
}: AvatarWithFallbackProps): JSX.Element | null => {
  const url = isNoAgentPhoto(imageUrl) ? undefined : imageUrl;

  return <Avatar imageUrl={url} {...props} />;
};

export default AvatarWithFallback;
